module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "destination",
    attrs: {
      "href": _vm.location.link
    }
  }, [_c('div', {
    staticClass: "destination__image",
    style: (_vm.background)
  }), _vm._v(" "), _c('div', {
    staticClass: "destination__name"
  }, [_vm._v(_vm._s(_vm.location.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef6e9d48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/destinations/location.vue
// module id = 188
// module chunks = 6